import { createApp } from "vue";
import App from "./App.vue";

import "./plugins/pwa";

import router from "./router";
import api from "./api";

import pinia from "./stores";
import { date } from "./plugins/date";
import { i18n } from "./plugins/i18n";

import installMask from "@/plugins/mask";
import installVuetify from "@/plugins/vuetify";
import installSeo from "@/plugins/seo";
import installRecaptcha from "@/plugins/recaptcha";
// import installErrorLogging from "@/plugins/error-logging";
import installSentry from "@/plugins/sentry";
import "@/plugins/window";

import "@/styles/sass/_app.scss";
import { registerComponents } from "@/components";
import { useSnackbar } from "./stores/snackbar";
import { useDialog } from "./stores/dialog";
import { useLoader } from "./stores/loader";
import { useAppStore } from "./stores/app";

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(i18n);

const appStore = useAppStore();
appStore.updateAppInfo();

app.config.globalProperties.$api = api;
app.config.globalProperties.$snackbar = useSnackbar();
app.config.globalProperties.$dialog = useDialog();
app.config.globalProperties.$loader = useLoader();
app.config.globalProperties.$date = date;

registerComponents(app);

// Install plugins
installVuetify(app);
installMask(app);
installSeo(app);
// installErrorLogging(app);
installRecaptcha();
installSentry(app);

app.mount("#app");
